import {fetchFromApi, getBackendApiURLModuleInstance} from "../../../BackendFacade";
import {
    AutomationConfig,
    displayToInternalName,
    DpasFileType,
    fileDetails,
    listDirectoryContent,
    Upload
} from "../constants";
import {IAutomationConfig} from "../Interfaces/IConfig";

/**
 * @param path Expects the following structure: [projectname
 * @param type
 * @param token Continuation token for pagination
 */
export function getDirContentNames(path: string, type: DpasFileType, token: string = null) {
    // adjust the type for the backend
    type = displayToInternalName(type);
    const tokenParam = token ? `&token=${token}` : ""
    const url = getBackendApiURLModuleInstance() + listDirectoryContent + "?path=" + path + "&type=" + type + tokenParam
    return fetchFromApi(url, "GET")
}

export function getAutomationConfig() {
    const url = getBackendApiURLModuleInstance() + AutomationConfig
    return fetchFromApi(url, "GET")
}

export function setAutomationConfig(body: IAutomationConfig) {
    const url = getBackendApiURLModuleInstance() + AutomationConfig
    return fetchFromApi(url, "PUT", body)
}

/**
 * returns NetworkData with data-type: IFileDetails
 * @param path relative path to file
 * @param type Constants.FolderImage or Constants.FolderDocuments
 */
export async function getFileAttributesSingle(path: string, type: DpasFileType) {
    const url = getBackendApiURLModuleInstance() + fileDetails
    // todo: why are we editing network data
    const ret = await fetchFromApi(url + "?type=" + type + "&filePath=" + path, "GET")
    ret.data.fileName = path
    return ret
}

export function UploadFile(directoryPath: string, file: File, containerType: string) {
    containerType = displayToInternalName(containerType);
    const url = getBackendApiURLModuleInstance() + Upload
    const body = {
        path: directoryPath + file.name,
        type: containerType
    }
    return fetchFromApi(url, "POST", body, "application/json", file)
}

export function deleteFile(filePath: string, containerType: string) {
    containerType = displayToInternalName(containerType);
    const url = getBackendApiURLModuleInstance() + `files?filePath=${filePath}&type=${containerType}`
    return fetchFromApi(url, "DELETE")
}

export function downloadFile(filePath: string, type: string, resolution: string = "", versionId: string = "") {
    let params = ""
    if (resolution !== "") {
        params = "&imageSize=" + resolution
    }
    if (versionId !== "") {
        params += "&versionId=" + versionId
    }
    const url = getBackendApiURLModuleInstance() + `downloadFile?filePath=${filePath}&type=${type}${params}`
    return fetchFromApi(url, "GET")
}

export function getNightlyResults() {
    const url = getBackendApiURLModuleInstance() + `orchestrationResults`
    return fetchFromApi(url, "GET")
}

export function startOrchestration() {
    const url = getBackendApiURLModuleInstance() + `triggerOrchestration`
    return fetchFromApi(url, "POST")
}